import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants';

export const Divider = () => {
  return <StyledDivider />;
};

const StyledDivider = styled.div`
  height: 1px;
  background-color: ${COLORS.DIVIDER_COLOR};
`;

Divider.displayName = 'Divider';
